export let HubInterestOption;

(function (HubInterestOption) {
  HubInterestOption["Sales"] = "sales";
  HubInterestOption["Marketing"] = "marketing";
  HubInterestOption["CustomerService"] = "customer-service";
  HubInterestOption["Operations"] = "operations";
  HubInterestOption["GeneralOverview"] = "general-overview";
  HubInterestOption["CMS"] = "cms";
})(HubInterestOption || (HubInterestOption = {}));